import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const formatPlanningMeasure = (value: ActualsValueTypes): string =>
  value === ActualsValueTypes.Ndp ? 'NDP' : value
